import React from 'react'

// will display elements of a single trending theme
export default function TrendingTheme({img, name}) {


    return (
        <div className='d-flex flex-column align-items-center trending_theme_container'>
            <div className='theme-img-container'>
                <img src={img} className='theme-img' alt='theme' />
            </div>
            <p className='theme-name'> {name} </p>
        </div>
    )
}
